<section id="wifi-voucher-connect" class="wifi-onboard-connect modal" data-modal="wifi-onboard-connect" style="display: block !important">
   <app-error *ngIf="showErrorMsg"></app-error>
   <div class="wrapper wrapperIpad">
     <div class="modal-body">
       <header>
         <button id="activate-close" type="button" class="modal-close" data-modal-close="wifi-onboard-connect" (click)="closeVoucherConnectOverlay()"
           tabindex="0" [attr.aria-label]="('close' | translate)">×</button>
         <div class="wifi-icon">
 
         </div>
         <h3 *ngIf="!isCharterFlight" id="activate-header" class="activate-header">Get started here</h3>
         <h3 *ngIf="isCharterFlight" id="activate-header" class="activate-header">Voucher Login</h3>
       </header>
       
       <div class="activate-content" [ngClass]="{'buyactivate-content':!showToggleButton, 'buyactivate-content-charter': showToggleButton && isCharterFlight}">
         <div class="toggle-btn-wrap" [ngClass]="{'pad-b-10': !showToggleButton, 'toggle-no-show': isCharterFlight}">
 
           <!-- <div class="row-block btn-wrapper my-trip-tab">
             <div class="toggle-button large-4 medium-6 small-12" *ngIf="showToggleButton && !isCharterFlight">
               <button id="bookRefAc" class="btn small" type="button" [ngClass]="{'active': showBokrefFileds}" (click)="toggleButtonChange('bref')"
                 tabindex="0" attr.aria-label="{{(bookAndEuro)?('wifiLogin.informationText' | translate)+('wifiLogin.type.pnr' | translate):''}}"
                 attr.aria-pressed="{{(showBokrefFileds)?'true':'false'}}" (keydown.tab)="keyEvent($event, '#eurobonusAcc')">{{'wifiLogin.type.pnr' | translate}}</button>
               <button id="eurobonusAcc" class="btn small" type="button" [ngClass]="{'active': showEuroBonusFileds}" (click)="toggleButtonChange('eb')"
                 tabindex="0" attr.aria-label="{{'wifiLogin.type.ebNumber' | translate}}" attr.aria-pressed="{{(showEuroBonusFileds)?'true':'false'}}">{{'wifiLogin.type.ebNumber' | translate}}</button>
             </div>
           </div> -->
           <div class="clear"></div>
         </div>
 
         <div class="wifi-eligibility-text mrgn-t-2" *ngIf="!showDisabledLoginFields && showEuroBonusFileds">
           <p class="wifi-notification-eurobonus">If you’re in SAS Go or Plus or have a EuroBonus Silver or Member status, use your booking reference to log in.</p>
         </div>
         <div class="wifi-eligibility-text mrgn-t-2" *ngIf="showEBforPointsBuy">
           <p class="wifi-notification-eurobonus">Please login using your EB Profile credentials to continue</p>
         </div>
         <div class="activate-form" [ngClass]="{'activate-cahrter-form': isCharterFlight}">
           <app-voucher-login (formSubmit)="connectToWifiPnr()" *ngIf="showBokrefFileds && !showEBforPointsBuy"></app-voucher-login>
           <app-eb-login (connectToWifi)="connectToWifiLogin()" class="hide-element" [ngClass]="{'show-element': ((!showDisabledLoginFields && showEuroBonusFileds) || showEBforPointsBuy)}"
             *ngIf="(showToggleButton && !isCharterFlight) || showEBforPointsBuy"></app-eb-login>
           <app-disabled-login-form (openSasTnc)="openSasTnC()" *ngIf="showDisabledLoginFields && showEuroBonusFileds"></app-disabled-login-form>
         </div>
         <div class="clear"></div>        
 
       </div>
       <div class="wifi-notification mrgn-t-30 text-info">
         <p class="text-white wifi-disclaimer text-padding" *ngIf="!showEBforPointsBuy">{{'wifi.disclaimer' | translate}}</p>
         <p class="text-white wifi-disclaimer text-padding" *ngIf="showEBforPointsBuy">The information you enter above will be used to verify your EuroBonus account.</p>
         <p class="text-white wifi-disclaimer">{{'wifi.disclaimer.text' | translate}}</p>
       </div>
       <!-- modal content end -->
     </div>
     <!-- modal body end -->
   </div>
 </section>
 <!-- modal end -->
 

<!-- <section class="buy-wifi-email text-white">
   <app-error></app-error>
   <div class="modal" id="myModal" style="display: block">
      <div class="modal-dialog medium">
         <div class="modal-content">
            <div class="modal-header">
               <button type="button" class="modal-close" data-modal-close="wifi-onboard-switch"
                  (keydown.enter)="closePaySelectionOverlay()" (click)="closeVoucherConnectOverlay()" tabindex="0"
                  id="close-switch" label='close'>×</button>
               <h4 class="modal-title" id="switch-header">CONNECT TO WIFI USING VOUCHER</h4>
            </div>
            <div class="modal-body">
               <form class="" role="form" name="buy-wifi-updateEmail" [formGroup]="voucherForm"
                  (ngSubmit)="voucherConnect()" novalidate="" form-autofill-fix="" autocomplete="off">
                  <div class="switch-content-wrapper">
                     <p>Please provide a valid WiFi voucher code for connecting your device to SAS WiFi</p>
                     <div class="req-info login">
                        <span>*Required Information</span>
                    </div>
                     <div class="input-set large-12 medium-12 small-12 col activate-input email-input">
                        <label id="emailLabel" [ngClass]="{'top-set': voucherTopSet}"  for="VoucherCode">Voucher
                           Code*</label>
                        <input formControlName='voucher' tabindex="0" id="update-email-input" name="" type="text"
                           aria-label="VoucherCode" required aria-required="true" aria-invalid="false" 
                           (focus)="onActiveVoucher()" aria-label="Email" (blur)="onBlurVoucher()" required/>
                           <div class="tool-tip bottom-left small error onboard-tool-tip" *ngIf="showVoucherError" role="alert">
                              <div class="tool-tip-inner">
                                 <div>{{voucherError}}</div>
                             </div>
                           </div>
                     </div>
                     <br>
                     <div class="wrap-button paySelect-points-container pull-right">
                        <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more">Continue</button>
                     </div>

                     <p [innerHtml]="'ebCampaign.instruction' | translate" id="ebCampInst"></p>
                  </div>
               </form>
            </div>
         </div>
      </div>
   </div>
</section> -->